"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("@emotion/react");

var _theme = require("../../theme/theme");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Space = function Space(_ref) {
  var className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "1" : _ref$size,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? "block" : _ref$display,
      _ref$isBox = _ref.isBox,
      isBox = _ref$isBox === void 0 ? true : _ref$isBox;

  var _size = _theme.MAP_SPACE[String(size)];

  var margin = 0;
  var height = 0;

  if (isBox) {
    height = _size;
  } else {
    margin = "calc(".concat(_size, " / 2)");
  }

  return (0, _react.jsx)("div", {
    className: className,
    css: (0, _react.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        display: ", ";\n        height: ", ";\n        margin-top: ", ";\n        margin-bottom: ", ";\n      "])), display, height, margin, margin)
  });
};

Space.propTypes = {
  className: _propTypes["default"].string,
  display: _propTypes["default"].oneOf(_theme.DISPLAY_TYPES),
  size: _propTypes["default"].oneOf(_theme.SPACE_TYPES),
  isBox: _propTypes["default"].bool
};
var _default = Space;
exports["default"] = _default;